import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DistrictData, DistrictOfficialData } from '../models/DistrictData';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DistrictOfficialService {
  apiUrl: string = "DistrictOfficial";
  constructor(private http: HttpClient) { 

  }
  getDistrictList():Observable<DistrictData>{
    return this.http.post<DistrictData>(environment.baseUrl + this.apiUrl + '/DistrictStateList/', null);
  }
  getDistrictOfficialData(policyNo: number):Observable<DistrictOfficialData[]>{
    const headers = { 'content-type': 'application/json'}  
    const body= JSON.stringify(policyNo);
    return this.http.post<DistrictOfficialData[]>(environment.baseUrl+this.apiUrl+'/DistrictOfficialsList',
     body, {headers: headers})
  }

}
